// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"461":"45854ec2","531":"7e25c3c5"}[chunkId] + ".chunk.css";
};